import React, {Component} from 'react'
import Footer from './footer'
import Header from './header'
import MaintenanceCheck from './MaintenanceCheck'
import {Col, Container} from '@amzn/stencil-react-components/layout'

class ApplicationLayout extends Component {
  render() {
    return (
      <Container>
        <Col margin={{left: "S300", right: "S300"}} gridGap="S400">
          <MaintenanceCheck/>
          <Header/>
            {this.props.children}
          <Footer/>
        </Col>
      </Container>
    )
  }
}

export default ApplicationLayout
